/** Prominent width when the bar is summoned at a cursor anchor. */
export const CURSOR_BAR_WIDTH = 500;
